import { Platform } from "react-native"
import messaging from "@react-native-firebase/messaging"
import { check, PERMISSIONS, RESULTS } from "react-native-permissions"
import { onUpdateFCMToken } from "./api"

export const getMobileFCMToken = async (accessToken, memberId) => {
  try {
    let permissionStatus
    let enabled

    if (Platform.OS === "android") {
      permissionStatus = await check(PERMISSIONS.ANDROID.POST_NOTIFICATIONS)
    } else if (Platform.OS === "ios") {
      // Request permission for notifications
      const authStatus = await messaging().requestPermission()

      enabled =
        authStatus === messaging.AuthorizationStatus.AUTHORIZED ||
        authStatus === messaging.AuthorizationStatus.PROVISIONAL

      // Check if APNs token is available
    }

    if (permissionStatus === RESULTS.GRANTED || enabled) {
      const apnsToken = await messaging().getAPNSToken()
      if (!apnsToken) {
        throw new Error("No APNs token available")
      }
      const fcmToken = await messaging().getToken()

      onUpdateFCMToken(accessToken, memberId, fcmToken)
      return fcmToken
    } else {
      // User declined permission, handle accordingly
    }
  } catch (error) {
    console.error("Error checking notification permissions: ", error)
    throw error
  }
}
